const style = document.createElement("style");
document.head.appendChild(style);

export const styleSheet = style.sheet;
